<template>
  <div class="xh-wrap">
    <myImg img="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner1.jpg"></myImg>
    <myTab
      :tab-list="tabList"
      @change="changeTab"
      :activeIndex="activeIndex"
      :bread-title="breadTitle"
      custom-event
      smallSize
    ></myTab>
    <template v-if="activeIndex == 0">
      <b-container>
        <div class="text-left bold mt-40  fs-24">{{ $t("mediacenter.mediacontact") }}</div>
        <!-- <div class="text-left bold mb-20 fs-24">For media, please contact:</div> -->
        <b-row>
          <b-col md="12" lg="6">
            <div class="item block-mb">
              <div class="item-title fs-24 pl-20 mb-20 ">
                {{ $t("pagebottom.executive1") }}
              </div>
              <div class="item-line fs-20">{{ $t('mediacenter.contactname')+ $t('mediacenter.name1')}}</div>
              <div class="item-line fs-20">
                {{ $t('mediacenter.contactphone') }}<a href="tel:020-89138049">020-89138049</a>
                <a href="tel:89138025">89138025</a>
              </div>
              <div class="item-line fs-20">
                <a href="mailto:chenb@autoguangzhou.com.cn"
                  >E-mail：chenb@autoguangzhou.com.cn</a
                >
              </div>
              <div class="item-line fs-20">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="mailto:tangj@autoguangzhou.com.cn"
                  >tangj@autoguangzhou.com.cn</a
                >
              </div>
            </div>
          </b-col>
          <b-col md="12" lg="6">
            <div class="item block-mb">
              <div class="item-title fs-24 pl-20 mb-20">
                {{ $t("pagebottom.sponsor4") }}
              </div>
              <div class="item-line fs-20">{{ $t('mediacenter.contactname')+$t('mediacenter.name2') }}</div>
              <div class="item-line fs-20">
                {{ $t('mediacenter.contactphone') }}<a href="tel:010-010-63368188">010-63368188转504</a>
              </div>
              <div class="item-line fs-20">
                <a href="mailto:heyingrui@auto-ccpit.org"
                  >E-mail：heyingrui@auto-ccpit.org</a
                >
              </div>
              <!-- <div class="item-line fs-20">
                {{ $t('mediacenter.please') }}
                <a
                  class="download"
                  target="_blank" 
                  href="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/gzcz_apply_data.zip"
                  >{{ $t('mediacenter.download') }}
                </a>
                {{ $t('mediacenter.cooperation1') }}
              </div> -->
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <template v-if="activeIndex == 1">
      <h2>暂未开通</h2>
    </template>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
import pageFooter from "@/components/pageFooter";
import myImg from "@/components/myImg";
import myTab from "@/components/myTab";
export default {
  components: {
    pageTop,
    pageFooter,
    myImg,
    myTab,
  },
  data() {
    return {
      tabList: [{
        title: this.$t("mediacenter.cooperation"),
        en: "Cooperation",
      }, {
        title: this.$t("mediacenter.pass"),
        en: "Media Pass",
      }],
      activeIndex: 0,
      breadTitle: {
        cn: this.$t("mediacenter.title"),
        en: "Media",
      }
    };
  },
  watch: {},
  methods: {
    changeTab(index) {
      if (index === 1) {
        return
        let routeData = this.$router.resolve({
          name: "mediaApply",
        });
        window.open(routeData.href, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$main: #42abff;
a {
  color: #fff;
}
.download {
  text-decoration: underline;
  color: $main;
}
.item {
  &-title {
    position: relative;
    &::before {
      position: absolute;
      left: 0;
      top: 0%;
      transform: translate(-50%);
      content: "";
      width: 10px;
      height: 100%;
      background: $main;
    }
  }
  &-line {
    color: #fff;
  }
}

@media screen and (min-width: 100px) and (max-width: 1000px) {
  .item-title {
    &::before {
      width: 30px;
    }
  }
  .block-mb {
    margin-bottom: 200px;
  }
}
@media screen and (min-width: 1000px) and (max-width: 2560px) {
  .container {
    padding: 0;
  }
  .block-mb {
    margin-bottom: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?af1bf306